import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import DialogForm from "../../shared/components/DialogForm";
import AddRoomRate from "./AddRoomRate";
import { connect } from "react-redux";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import {
  roomsRateListFailed,
  roomsRateListSuccess,
} from "../../Reducer/roomRateSlice";
import {
  deleteRoomRateApiCall,
} from "../../apis/services/RoomRateService";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";
import ConfirmDialog from "../../shared/components/ConfirmDialog";
import { ApiEndPoints } from "../../apis/ApiEndPoints";
import { fetchList } from "../../apis/services/CommonApiService";
import Loader from "../../layout/Loader";
import { useTranslation } from "react-i18next";
import {
  convertToKeyValue,
  getLanguageCode,
  getPermissionList,
} from "../../utils/helper";
import { roomRateDatagridOptionsSuccess, roomRateSearchFiltersSuccess } from "../../Reducer/roomRateTabSlice";

const Roomrates = (props) => {
  const { roomsRateList, roomsRateListSuccess, roomsRateListFailed,
    ratesDatagridOptions,
    searchFilters,
    datagridOptionsSucces,
    searchFilterSucces,
   } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const setSearchFilters = (props) => {
    searchFilterSucces(convertToKeyValue(props));
  };

  const updateRatesDatagridOptions = (k, v) =>
    datagridOptionsSucces({ key: k, value: v });

  const getRoomRateList = useCallback(async () => {
    // console.log("Api Call");
    if (ratesDatagridOptions?.rows?.length === 0) {
      updateRatesDatagridOptions("loading", true);
    }
  
    const result = await fetchList(
      ApiEndPoints.ROOM_RATES_RESOURCE_ROUTE +
        `?page_no=${ratesDatagridOptions.page}&items_per_page=${ratesDatagridOptions.pageSize}&search_text=${searchFilters.searchText}&rate_status=${searchFilters.rateActivityStatus}`
    );
    if (result?.status === 200) {
      updateRatesDatagridOptions("totalRows", result.data.totalRows);
      roomsRateListSuccess(result.data.rows);
      updateRatesDatagridOptions("loading", false);
    } else {
      updateRatesDatagridOptions("totalRows", 0);
      roomsRateListFailed();
      updateRatesDatagridOptions("loading", false);
    }
  }, [
    ratesDatagridOptions.page,
    ratesDatagridOptions.pageSize,
    searchFilters.searchText,
    searchFilters.rateActivityStatus,
  ]);

  useEffect(() => {
    getRoomRateList();
  }, [getRoomRateList]);

  const setRatesData = (data) => {
    const ratesDatagridRows = data?.map((item, index) => {
      return {
        id: item.id,
        name: item.name,
        // meal_price: item.meal_price,
        cancelation_policy: item.cancellationPolicyDetails?.name,
        actions: "Actions",
      };
    });
    updateRatesDatagridOptions("rows", ratesDatagridRows);
  };

  useEffect(() => {
    setRatesData(roomsRateList);
  }, [roomsRateList]);

  const [alignment, setAlignment] = React.useState("left");

  // const handleActiveInactiveChange = (event, newAlignment) => {
  //   console.log(event.target.value);
  //   setAlignment(newAlignment);
  // };

  const handleActiveInactiveChange = (event, newAlignment) => {
    const { value } = event.target;
    if (value && value != "") {
      setSearchFilters({
        rateActivityStatus: value,
      });
    }
    updateRatesDatagridOptions("page", 1);
    setAlignment(newAlignment);
  };

  const handleRateSearch = (event) => {
    const { value } = event.target;
      setSearchFilters({
        searchText: value,
      });
      updateRatesDatagridOptions("page", 1);
  };

  const editRate = React.useCallback(
    (id) => () => {
      navigate(`/edit-room-rates/${id}`);
    },
    []
  );

  //delete room rate api
  const [loading, setLoading] = React.useState(false);
  const [openDeleteRoomRateDialog, setOpenDeleteRoomRateDialog] =
    React.useState(false);
  const handleCloseDeleteRoomRateDialog = () =>
    setOpenDeleteRoomRateDialog(false);
  const [deleteRoomRateId, setDeleteRoomRateId] = useState(0);
  const handleConfirmDeleteRoomRateAction = async () => {
    setLoading(true);
    setOpenDeleteRoomRateDialog(false);
    const result = await deleteRoomRateApiCall(deleteRoomRateId);
    if (result?.status === 200) {
      setLoading(false);
      toast.success(t(result.message));
      getRoomRateList();
    } else {
      setLoading(false);
      toast.error(t(result.message));
    }
  };
  const deleteRate = React.useCallback(
    (id) => () => {
      setDeleteRoomRateId(id);
      setOpenDeleteRoomRateDialog(true);
    },
    []
  );

  const ratesDatagridColumns = [
    { field: "name", headerName: t("Rate Name"), flex: 1 },
    {
      field: "cancelation_policy",
      headerName: t("Cancellation policy"),
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      headerName: t("Actions"),
      flex: 1,
      getActions: (params) => {
        const actions = [];

        if (getPermissionList("Room rates", 3)?.hasPermission) {
          actions.push(
            <GridActionsCellItem
              label={t("Edit")}
              onClick={editRate(params.id)}
              showInMenu
            />
          );
        }

        if (getPermissionList("Room rates", 4)?.hasPermission) {
          actions.push(
            <GridActionsCellItem
              label={t("Delete")}
              onClick={deleteRate(params.id)}
              showInMenu
            />
          );
        }

        return actions;
      },
    },
  ];

  const [openDialog, setOpenDialog] = React.useState(false);
  const handleDialogClose = () => setOpenDialog(false);

  return (
    <div className="main-layout-background h-auto">
      {loading && <Loader />}
      <div className="d-flex mb-2 pr-2 justify-content-between align-items-center">
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item lg={4}>
            <FormControl fullWidth>
              <TextField
                label={t("Search Rate Name")}
              value={searchFilters?.searchText}
                onChange={(event) => {
                  handleRateSearch(event);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
          </Grid>
          <Grid item lg={4}>
            <ToggleButtonGroup
              color="primary"
              value={alignment}
              exclusive
              onChange={handleActiveInactiveChange}
              aria-label="Platform"
            >
              <ToggleButton style={{ marginTop: "0px" }} value="1" xs={4}>
                {t("Active")}
              </ToggleButton>
              <ToggleButton style={{ marginTop: "0px" }} value="0">
                {t("Not Active")}
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        </Grid>

        
      </div>
      <div>

        <DataGrid
          localeText={
            getLanguageCode().components.MuiDataGrid.defaultProps.localeText
          }
          density="compact"
          autoHeight
          getRowHeight={() => "auto"}
          pagination
          paginationMode="server"
          loading={ratesDatagridOptions.loading}
          rowCount={ratesDatagridOptions.totalRows}
          rowsPerPageOptions={ratesDatagridOptions.rowsPerPageOptions}
          // rows={ratesDatagridRows}
          rows={ratesDatagridOptions.rows}
          columns={ratesDatagridColumns}
          page={ratesDatagridOptions.page - 1}
          pageSize={ratesDatagridOptions.pageSize}
          checkboxSelection={true}
          onPageChange={(newPage) => {
            updateRatesDatagridOptions("page", newPage + 1);
          }}
          onPageSizeChange={(pageSize) => {
            updateRatesDatagridOptions("page", 1);
            updateRatesDatagridOptions("pageSize", pageSize);
          }}
        />
      </div>

      <DialogForm
        scroll="paper"
        maxWidth="xl"
        title={t("Create room rate")}
        openDialog={openDialog}
        handleDialogClose={handleDialogClose}
        bodyContent={<AddRoomRate handleDialogClose={handleDialogClose} />}
      />

      {/* Delete Room Rate Alert */}
      <ConfirmDialog
        scroll="paper"
        maxWidth="md"
        title={t("Confirm The Action")}
        message={t("Do you really want to delete the room rate data?")}
        cancelButtonText={t("Cancel")}
        confirmButtonText={t("Delete")}
        openDialog={openDeleteRoomRateDialog}
        handleDialogClose={handleCloseDeleteRoomRateDialog}
        handleDialogAction={handleConfirmDeleteRoomRateAction}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    roomsRateList: state.roomRate.roomsRateList,
    ratesDatagridOptions: state.roomRateTab?.roomRateDatagridOptions,
    searchFilters: state.roomRateTab?.roomRateSearchFilters,

  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    roomsRateListSuccess: (data) => dispatch(roomsRateListSuccess(data)),
    roomsRateListFailed: () => dispatch(roomsRateListFailed()),   
    datagridOptionsSucces: (data) => dispatch(roomRateDatagridOptionsSuccess(data)),
    searchFilterSucces: (data) => dispatch(roomRateSearchFiltersSuccess(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Roomrates);
